import { render, staticRenderFns } from "./dog-request-details.vue?vue&type=template&id=097713b3&scoped=true&lang=pug"
import script from "./dog-request-details.js?vue&type=script&lang=js&external"
export * from "./dog-request-details.js?vue&type=script&lang=js&external"
import style0 from "./dog-request-details.vue?vue&type=style&index=0&id=097713b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097713b3",
  null
  
)

export default component.exports